module.exports = __webpack_public_path__ + "media/images/plans/plan-detail-photo-planner-2-e5637bf2f1ba617160660f0e2f718352.jpg";